import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddProductsAsAlternateToListForm from '../add-products-as-alternate-form';
import { useRecoilState } from 'recoil';
import { pinnedSelectionState } from '../../recoils/usePinnedSelection/isPinnedSelectionAtom';

interface IProp {
  numberOfSelected: number;
  gridApi: any;
  isReverse: boolean;
  listId: string;
  uniqueId: string;
  searchQuery: string;
}

export const AddProductsAsAlternate: React.FC<IProp> = ({
  numberOfSelected,
  gridApi,
  isReverse,
  listId,
  uniqueId,
  searchQuery
}) => {
  const { t } = useTranslation();

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedDataState, setSelectedDataState] = useState<any>();
  const [pinnedRowData, setPinnedRowData] = useState<any>();
  const [pinnedSelected] = useRecoilState(pinnedSelectionState);
  const toggleForm = () => setIsFormOpen(!isFormOpen);

  const addProductsAsAlternateToListHandler = async (e: any) => {
    e.preventDefault();

    if (gridApi && !gridApi.destroyCalled) {
      // ! Get selected data when
      const selectedNodes = gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map((node: any) => node.data);
      setSelectedDataState(selectedData);
      if(pinnedSelected) {
        const pinnedTopRow = gridApi.getPinnedTopRow(0);
        setPinnedRowData(pinnedTopRow);
      } else {
        setPinnedRowData(undefined);
      }
      
      toggleForm();
    }
  }

  return (
    <div>
      <button
        className="dk-btn__primary"
        onClick={addProductsAsAlternateToListHandler}
        id="add-product-alternate-to-list-button"
        data-testid="addProductAlternateToListBtn"
      >
        {t('xref-add')}{' '}
        {numberOfSelected} {(numberOfSelected > 1 || numberOfSelected > 0 && pinnedSelected) ? t('xref-products') : t('xref-product')} {' '}
        {numberOfSelected > 1 ? t('xref-as-alternates') : t('xref-as-alternate')}
      </button>

      <AddProductsAsAlternateToListForm
        isFormOpen={isFormOpen}
        setIsFormOpen={setIsFormOpen}
        selectedData={selectedDataState}
        isReverse={isReverse}
        listId={listId}
        uniqueId={uniqueId}
        searchQuery={searchQuery}
        pinnedRowData={pinnedRowData}
      ></AddProductsAsAlternateToListForm>

    </div >
  )
}
